import { Grid, GridColumn, Tooltip, TooltipToggle } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../services/AnalyticsService';
import { ITranslateStore } from '../../stores/TranslateStore';
import { formatAsCurrency } from '../../util/FormatUtil';
import UnsettledReceivablesStore from '../../stores/UnsettledReceivablesStore';
import { formatDate } from '../../util/DateUtil';

interface ITotalPrepaymentAmountProps {
  unsettledReceivablesStore?: UnsettledReceivablesStore;
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
}

@inject('unsettledReceivablesStore', 'translateStore', 'analyticsService')
@observer
export default class TotalPrepaymentAmount extends React.Component<ITotalPrepaymentAmountProps> {
  public componentDidMount(): void {
    this.props.analyticsService.invoicesOnPrePaymentDisplayed();
  }

  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const unsettledReceivablesStore = this.props.unsettledReceivablesStore;

    return (
      <React.Fragment>
        <Tooltip
          fixedWidth={false}
          referenceElement={
            <TooltipToggle id="unpaid-invoices-prepayment-tooltip">{formatAsCurrency(unsettledReceivablesStore.totalPrepayment)}</TooltipToggle>
          }
        >
          <p className="h5">{translate('invoices.unpaid-invoices.invoices.amount-prepayment')}</p>
          {unsettledReceivablesStore.unsettledReceivables.payload.prepayments.map((prepayment, prepaymentKey) => {
            return (
              <React.Fragment key={prepaymentKey}>
                <Grid align={['between-xs']} className="text-small" key={prepaymentKey}>
                  <GridColumn width={['xs']}>{formatDate(prepayment.date)}</GridColumn>
                  <GridColumn width={['xs']} className="text-bold">
                    {formatAsCurrency(prepayment.amount)}
                  </GridColumn>
                </Grid>
                {prepayment.description ? (
                  <Grid>
                    <GridColumn>{prepayment.description}</GridColumn>
                  </Grid>
                ) : null}
                {prepayment.creditInvoiceNumber ? (
                  <Grid>
                    <GridColumn>
                      {translate('invoices.unpaid-invoices.credit-invoice-description', {
                        creditInvoiceNumber: prepayment.creditInvoiceNumber
                      } as any)}
                    </GridColumn>
                  </Grid>
                ) : null}
              </React.Fragment>
            );
          })}
        </Tooltip>
      </React.Fragment>
    );
  }
}
